export default "__VITE_ASSET__8d38f12c__"